'use client'

import MyGames from 'pageContainers/MyGames/Games'
import { useAppSelector } from 'src/store/hooks'
import { playedBingoGamesSelector, playedGamesLayoutSelector } from 'store/modules/playedGames/selectors'

import t from '../../../utils/getTranslationClient'

export default function BingoGames() {
  const games = useAppSelector(playedBingoGamesSelector)
  const layout = useAppSelector(playedGamesLayoutSelector)

  return <MyGames games={games} gameType='bingo' title={t('my_bingo_games')} dataTestId='game-tiles-container' layout={layout} />
}
